
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  commonModule,
  tasksModule,
  actionTypesModule,
  itemsModule,
  dashboardModule,
} from "@/store/modules/store-accessor";
import { getOptimalTextColor, primaryInstallationItemText } from "@/helpers/data";
import AssigneeCombo from "@/components/Combobox/AssigneeCombo.vue";
import _ from "lodash";
import { TimeUtil } from "@/helpers/TimeUtil";
import AssigneeMultiUserCombo from "@/components/Combobox/AssigneeMultiUserCombo.vue";
import PriorityCombo from "@/components/Combobox/PriorityCombo.vue";
import AppointmentCalendar from "@/components/Calendar/AppointmentCalendar.vue";
import EventOverlappingWarning from "@/components/Alerts/EventOverlappingWarning.vue";
import InstallationItemWarrantyIndicator from "@/components/InstallationItemWarrantyIndicator.vue";
import { greekSearchFilter } from "@/helpers/data";

@Component({
  components: {
    AssigneeCombo,
    AssigneeMultiUserCombo,
    PriorityCombo,
    AppointmentCalendar,
    EventOverlappingWarning,
    InstallationItemWarrantyIndicator,
  },
})
export default class AddTaskModal extends Vue {
  @Prop()
  payload!: any;

  greekSearchFilter = greekSearchFilter;

  isAddingTask = false;

  dateMenu = false;
  timeMenu = false;

  isCompleted = false;
  loadingInstallationPrimaryItems = true;

  taskModel = {
    due_at: this.formatDate(new Date()),
    assignee_id: "",
    installation_id: "",
    task_status_id: -1,
    title: "",
    notes: "",
    action_type_id: null,
    installation_item_id: { primary_items: "", id: 0 },
    scheduled_start_time: "",
    all_day: true,
    assignee_ids: [] as any[],
    priority_name: null,
  };

    updateAssignees(assignees: any[]) {
    if (assignees.length > 0) {
      this.taskModel.assignee_id = assignees[0];
    }
    this.taskModel.assignee_ids = assignees;
  }

  clearDatetime() {
    this.taskModel.scheduled_start_time = "";
    this.taskModel.all_day = false;
  }

  get actionsCombo() {
    return actionTypesModule.actionTypesCombo;
  }

  get isLoadingInstallationPrimaryItems() {
    return this.loadingInstallationPrimaryItems;
  }

  get disablePrimaryItems() {
    return (
      this.loadingInstallationPrimaryItems ||
      this.installationPrimaryItems.length === 0
    );
  }

  get installationPrimaryItems() {
    return itemsModule.installationPrimaryItems;
  }

  primaryItemText(item: Record<string, any>) {
    return primaryInstallationItemText(item);
  }

  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  defaultInstallationItem() {
    if (
      this.installationPrimaryItems &&
      this.installationPrimaryItems.length === 1
    ) {
      return this.installationPrimaryItems[0];
    }
    return { primary_items: "", id: 0 };
  }

  notesRule = [
    (val: any) => val.length <= 1000 || this.$i18n.t("notesLengthRule"),
  ];
  titleRule = [
    (val: any) => !!val || this.$i18n.t("title_required"),
    (val: any) => val.length <= 300 || this.$i18n.t("form_title_length_rule"),
  ];
  scheduledTimeRules() {
    if (this.taskModel.due_at) {
      return [(val: any) => !!val || this.$i18n.t("timeRequired")];
    }
    return [];
  }

  async hideModal() {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
    commonModule.getPersonnelCombo();
    await actionTypesModule.getActionTypesCombo();

    this.loadingInstallationPrimaryItems = true;
    if (this.payload.installation && this.payload.installation.info.id) {
      await itemsModule.getInstallationPrimaryInventoryItems(
        this.payload.installation.info.id
      );
    }
    (this.taskModel.installation_item_id as any) =
      this.defaultInstallationItem();
    this.loadingInstallationPrimaryItems = false;
  }

  get showTimeInput() {
    return !this.taskModel.all_day;
  }

  formatDate(date: Date): string {
    return TimeUtil.formatDateOnly(date);
  }

  async doAddTask() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      let taskModelCopy = _.cloneDeep(this.taskModel);
      this.isAddingTask = true;
      taskModelCopy.task_status_id = this.isCompleted ? 3 : 2; // -> 3 completed -> 2 pending
      taskModelCopy.installation_id =
        this.payload.installation && this.payload.installation.info.id
          ? this.payload.installation.info.id
          : null;
      await tasksModule.addTask(taskModelCopy);

      if (this.$route.name === "Tasks") {
        await tasksModule.getTasks(tasksModule.filters);
      } else if (this.$route.name === "Dashboard") {
        dashboardModule.getDashboardPendingTasks(dashboardModule.taskFilters);
      }

      this.isAddingTask = false;
      this.hideModal();
    }
  }
}
